<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-inspeccion"
      style="background-color: #00000082"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Inspección</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card-body p-0">
              <table
                class="table table-striped table-bordered table-hover table-md"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Inspeccion</th>
                    <th class="text-center text-nowrap">Acción</th>
                  </tr>
                </thead>
                <tbody v-if="arrayFinal.length > 0">
                  <tr
                    v-for="item of arrayFinal"
                    :key="item.formato_inspeccion_id"
                  >
                    <td>
                      <div>{{ item.info_formato.nombre }}</div>
                      <small
                        v-if="mostrarNombreUltimaMensual(item)"
                        class="d-block text-muted"
                      >
                        {{ nombreFormatoUltimaMensual(entidad) }}
                      </small>
                      <span
                        v-if="esFormatoMensual(item)"
                        class="badge d-inline-block text-wrap mt-1"
                        :class="valInspeccionFechasMsgBadge(entidad)"
                      >
                        {{ valInspeccionFechasMsg(entidad, item) }}
                      </span>
                    </td>
                    <td class="text-center text-nowrap align-middle">
                      <button
                        v-if="item.info && item.info.id"
                        type="button"
                        class="btn btn-sm btn-default py-0"
                        style="cursor: pointer"
                        @click="edit(item.info.id)"
                      >
                        {{ item.info.id }}
                      </button>
                      <button
                        v-else-if="mostrarBotonCrear(item)"
                        type="button"
                        class="btn btn-info"
                        style="cursor: pointer"
                        @click="inspeccion(item.info_formato)"
                      >
                        <i class="fas fa-plus-square"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="2" class="text-center text-muted">
                      No hay formatos de inspección activos asignados a este
                      sitio.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "GestionInspeccionHidrocarburos",
  components: {},
  data() {
    return {
      arrayFinal: [],
      sitioFormatos: {},
      entidadInspeccion: [],
      entidad: {},
      entidad_id: null,
      tipo_entidad: null,
      listaPeriocidad: [],
    };
  },
  methods: {
    async llenarModalInspeccion(entidad, tipo_entidad) {
      this.entidad_id = entidad.id;
      this.tipo_entidad = tipo_entidad;
      await this.getListaPeriocidad();
      this.cargarInspecciones();
    },

    cargarInspecciones() {
      let me = this;
      axios
        .get(
          "/api/admin/centralTrafico/cargarInspeccion?entidad_id=" +
            this.entidad_id +
            "&tipo_entidad=" +
            this.tipo_entidad
        )
        .then(async (response) => {
          me.$parent.cargando = false;
          let res = response.data;
          if (res.Msg == "error") {
            const entidadesConError = [];
            if (res.errors.vehiculo.error !== undefined) {
              entidadesConError.push("Vehículo");
              await this.msgDocumentacion(res.errors.vehiculo, "Vehiculo");
            }
            if (res.errors.remolque.error !== undefined) {
              entidadesConError.push("Remolque");
              await this.msgDocumentacion(res.errors.remolque, "Remolque");
            }
            if (res.errors.conductor.error !== undefined) {
              entidadesConError.push("Conductor");
              await this.msgDocumentacion(res.errors.conductor, "Conductor");
            }
            const detalle =
              entidadesConError.length > 0
                ? `Documentación pendiente en: ${entidadesConError.join(", ")}`
                : "Documentación pendiente";
            this.$swal({
              icon: "error",
              title:
                "No se puede realizar inspeccion hasta que la documentacion cumpla",
              text: detalle,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.$refs.closeModal.click();
            return;
          }
          me.sitioFormatos = res.formatos;
          me.entidadInspeccion = res.inspecciones ? res.inspecciones : [];
          me.entidad = res.entidad;
          me.arrayFinal = [];
          if (
            me.sitioFormatos &&
            me.sitioFormatos.inspecciones &&
            me.sitioFormatos.inspecciones.length
          ) {
            await this.cruceInspeccion();
          }
        });
    },

    async cruceInspeccion() {
      this.arrayFinal = [];
      const formatosAsignados =
        this.sitioFormatos && Array.isArray(this.sitioFormatos.inspecciones)
          ? this.sitioFormatos.inspecciones
          : [];

      formatosAsignados.forEach((element) => {
        const formatoId =
          (element.pivot && element.pivot.formato_inspeccion_id) || element.id;
        let cruce = {
          formato_inspeccion_id: formatoId,
          info_formato: element,
          info: null,
        };

        if (this.entidadInspeccion && this.entidadInspeccion.length > 0) {
          for (let i = 0; i < this.entidadInspeccion.length; i++) {
            const inspeccion = this.entidadInspeccion[i];
            if (
              inspeccion &&
              String(inspeccion.formato_inspeccion_id) === String(formatoId)
            ) {
              cruce.info = inspeccion;
              break;
            }
          }
        }

        this.arrayFinal.push({ ...cruce });
      });

      const tieneGuia = this.entidad && this.entidad.guia_id != null;
      const esGnv =
        this.entidad &&
        this.entidad.vehiculo &&
        this.entidad.vehiculo.tipo_combustible == 1;

      this.arrayFinal = this.arrayFinal.filter((item) => {
        if (item.info && item.info.id) {
          return true;
        }

        if (this.esFormatoPreoperacional(item)) {
          return true;
        }

        const formato = item.info_formato || {};
        if (formato.estado != null && Number(formato.estado) !== 1) {
          return false;
        }

        if (this.esFormatoMarcadoGnv(formato)) {
          return !!esGnv;
        }

        if (this.tieneParGnvMismaPeriocidad(formato, formatosAsignados)) {
          return !esGnv;
        }

        if (formato.tipo_operacion == 2 && !tieneGuia) {
          return false;
        }
        if (formato.tipo_operacion == 1 && tieneGuia) {
          return false;
        }
        return true;
      });
    },

    inspeccion(inspeccionFormato) {
      this.$refs.closeModal.click();
      this.$store.dispatch("getMenus", 2);
      this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
      this.$store.dispatch("setRoutes");
      this.permisoLineaNegocio(2);
      const sitio = this.obtenerSitioInspeccion();
      if (!sitio || !sitio.id) {
        this.$swal({
          icon: "warning",
          title: "No se encontró el sitio para inspección",
          text: "Valida la información de la solicitud y el sitio asociado.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      // Determinar sitio_type basado en el tipo de entidad
      let sitioType = null;
      if (this.tipo_entidad == "Viaje") {
        // Si es viaje, usar el sitio_type del viaje o determinar según el sitio
        sitioType = this.entidad.sitio_type;
        // Si no tiene sitio_type, intentar determinar desde el sitio
        if (!sitioType) {
          sitioType = "App\\Sitio"; // Por defecto
        }
      } else {
        sitioType = "App\\Sitio";
      }

      // Convertir sitio_type a formato numérico si es necesario (1 = Sitio, 2 = PuntoGestion)
      let sitioTypeNum = null;
      if (sitioType === "App\\Sitio" || sitioType === "App//Sitio") {
        sitioTypeNum = 1;
      } else if (sitioType === "App\\PuntoGestion") {
        sitioTypeNum = 2;
      } else {
        sitioTypeNum = sitioType; // Ya es numérico
      }

      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          viaje: this.entidad,
          inspeccion: inspeccionFormato, // Pasar el formato de inspección
          sitio_type: sitioTypeNum,
          sitio: sitio, // Pasar el objeto sitio completo
          val: 0,
        },
      });
    },

    inspeccionPreoperacional() {
      this.$refs.closeModal.click();
      this.$store.dispatch("getMenus", 2);
      this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
      this.$store.dispatch("setRoutes");
      this.permisoLineaNegocio(2);
      const sitio = this.obtenerSitioInspeccion();
      if (!sitio || !sitio.id) {
        this.$swal({
          icon: "warning",
          title: "No se encontró el sitio para inspección",
          text: "Valida la información de la solicitud y el sitio asociado.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      // Determinar sitio_type basado en el tipo de entidad
      let sitioType = 1; // Por defecto Sitio
      if (this.tipo_entidad == "Viaje" && this.entidad.sitio_type) {
        // Si es viaje y tiene sitio_type, usarlo
        if (
          this.entidad.sitio_type === "App\\Sitio" ||
          this.entidad.sitio_type === "App//Sitio"
        ) {
          sitioType = 1;
        } else if (this.entidad.sitio_type === "App\\PuntoGestion") {
          sitioType = 2;
        } else {
          sitioType = this.entidad.sitio_type; // Ya es numérico
        }
      }

      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          viaje: this.entidad, // Usar 'viaje' en lugar de 'entidad' para consistencia
          sitio_type: sitioType,
          sitio: sitio, // Pasar el objeto sitio completo
          val: 0,
        },
      });
    },

    obtenerSitioInspeccion() {
      let sitioId = null;
      let sitioObj = null;

      if (this.tipo_entidad == "Viaje") {
        sitioId = this.entidad?.sitio_id || null;
        // Si el viaje tiene un objeto sitio, usarlo
        if (this.entidad?.sitio) {
          sitioObj = this.entidad.sitio;
        }
      } else {
        // Para otros tipos de entidad (Postulación, etc.)
        const solicitudSnake =
          this.entidad?.det_solicitud_diaria?.solicitud_diaria;
        if (solicitudSnake?.sitio_id) {
          sitioId = solicitudSnake.sitio_id;
          // Si tiene objeto sitio, usarlo
          if (solicitudSnake.sitio) {
            sitioObj = solicitudSnake.sitio;
          }
        } else {
          const solicitudCamel =
            this.entidad?.detSolicitudDiaria?.solicitudDiaria;
          if (solicitudCamel?.sitio_id) {
            sitioId = solicitudCamel.sitio_id;
            // Si tiene objeto sitio, usarlo
            if (solicitudCamel.sitio) {
              sitioObj = solicitudCamel.sitio;
            }
          }
        }
      }

      // Si tenemos el objeto completo, devolverlo
      if (sitioObj && sitioObj.id) {
        return sitioObj;
      }

      // Si solo tenemos el ID, crear un objeto mínimo con el ID
      if (sitioId) {
        return { id: sitioId };
      }

      return null;
    },

    async msgDocumentacion(res, entidad) {
      if (res.error) {
        let erroHtml = "<div>";
        if (res.error.documentos) {
          if (res.error.documentos.obligatorios) {
            erroHtml += "<b>Pendiente:</b><br>";
            erroHtml += res.error.documentos.obligatorios.join("<br>");
          }
          if (res.error.documentos.vencidos) {
            erroHtml += "<br><b>Vencidos:</b><br>";
            for (let i = 0; i < res.error.documentos.vencidos.length; i++) {
              erroHtml +=
                res.error.documentos.vencidos[i].documento +
                " - " +
                res.error.documentos.vencidos[i].fecha_vencimiento +
                "<br>";
            }
          }
          if (res.error.documentos.no_verificados) {
            erroHtml += "<br><b>No Verificados:</b><br>";
            erroHtml += res.error.documentos.no_verificados.join("<br>");
          }
        }
        erroHtml += "</div>";
        await this.$swal({
          html: erroHtml,
          showCancelButton: false,
          focusConfirm: true,
          icon: "info",
          title: "Aviso en documentacion " + entidad,
          showConfirmButton: false,
          showCloseButton: true,
          footer:
            "<small style='text-align:center'>El " +
            entidad +
            " no pasa las validaciones documentales, para mas informacion comuniquese con la mesa de ayuda al siguiente numero <b>3176431376 Opción 3</b></small>",
        });
      }
    },

    edit(inspeccion_id) {
      this.$refs.closeModal.click();
      this.$store.dispatch("getMenus", 2);
      this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
      this.$store.dispatch("setRoutes");
      this.permisoLineaNegocio(2);
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          inspeccion_id: inspeccion_id,
        },
      });
    },

    permisoLineaNegocio(linea_negocio) {
      let lineasUser = this.$store.state.user.lineas_negocio;
      return (
        lineasUser.find((linea) => linea.id === linea_negocio) !== undefined
      );
    },

    parsearFechaHora(valor) {
      if (!valor) return null;
      if (valor instanceof Date) return valor;
      if (typeof valor !== "string") return null;

      const normalizado = valor.includes("T") ? valor : valor.replace(" ", "T");
      const fecha = new Date(normalizado);
      if (!Number.isNaN(fecha.getTime())) {
        return fecha;
      }

      const partes = valor.split(" ");
      if (partes.length !== 2) return null;
      const [fechaParte, horaParte] = partes;
      const [anio, mes, dia] = fechaParte.split("-").map(Number);
      const [hora, minuto, segundo] = horaParte.split(":").map(Number);
      if (!anio || !mes || !dia || hora === undefined || minuto === undefined) {
        return null;
      }
      return new Date(anio, mes - 1, dia, hora, minuto, segundo || 0);
    },

    esNombrePreoperacional(nombre) {
      const n = String(nombre || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return (
        n.indexOf("preoperacional") !== -1 || /pre[\s\-_.]*operacional/.test(n)
      );
    },

    esFormatoPreoperacional(item) {
      const formato =
        (item && (item.info_formato || item.formato_inspeccion)) || {};
      const flag = formato.pre_operacional;
      if (flag == 1 || flag === true || flag === "1" || flag === "true") {
        return true;
      }
      return this.esNombrePreoperacional(formato.nombre);
    },

    esFormatoMarcadoGnv(formato) {
      if (!formato) {
        return false;
      }
      if (formato.gnv == 1 || formato.gnv === true) {
        return true;
      }
      return /\bgnv\b/i.test(formato.nombre || "");
    },

    tieneParGnvMismaPeriocidad(formato, formatosAsignados) {
      if (!formato || !Array.isArray(formatosAsignados)) {
        return false;
      }
      return formatosAsignados.some((otro) => {
        if (!otro || otro.id == formato.id) {
          return false;
        }
        const otroItem = { info_formato: otro };
        if (this.esFormatoPreoperacional(otroItem)) {
          return false;
        }
        if (!this.esFormatoMarcadoGnv(otro)) {
          return false;
        }
        const diasFormato = this.diasPeriocidad(formato);
        const diasOtro = this.diasPeriocidad(otro);
        if (diasFormato != null && diasOtro != null) {
          return diasFormato === diasOtro;
        }
        return (
          String(otro.periocidad ?? "") === String(formato.periocidad ?? "")
        );
      });
    },

    itemPeriocidad(formato) {
      const valor = formato && formato.periocidad;
      if (valor === null || valor === undefined || valor === "") {
        return null;
      }
      return (
        (this.listaPeriocidad || []).find(
          (item) =>
            String(item.numeracion) === String(valor) ||
            String(item.id) === String(valor) ||
            String(item.cod_alterno) === String(valor),
        ) || null
      );
    },

    diasPeriocidad(formato) {
      const item = this.itemPeriocidad(formato);
      if (item && item.cod_alterno !== null && item.cod_alterno !== "") {
        const dias = Number(item.cod_alterno);
        if (!Number.isNaN(dias)) {
          return dias;
        }
      }
      const directo = Number(formato && formato.periocidad);
      return Number.isNaN(directo) ? null : directo;
    },

    normalizarTexto(valor) {
      return String(valor || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },

    esCargueODescargue(formato) {
      const tipo = Number(formato && formato.tipo_operacion);
      return tipo === 1 || tipo === 2;
    },

    esFormatoMensual(item) {
      const formato = item && item.info_formato;
      if (!formato || this.esFormatoPreoperacional(item)) {
        return false;
      }
      if (this.diasPeriocidad(formato) === 30) {
        return true;
      }
      if (this.esFormatoMarcadoGnv(formato)) {
        return true;
      }
      const nombre = this.normalizarTexto(formato.nombre);
      if (
        nombre.indexOf("col-hs") !== -1 ||
        nombre.indexOf("mercancias peligrosas") !== -1
      ) {
        return true;
      }
      return !this.esCargueODescargue(formato);
    },

    mostrarBotonCrear(item) {
      if (!item || (item.info && item.info.id) || !this.entidad) {
        return false;
      }

      const mensualVencida = this.mensualEstaVencida(this.entidad, item);

      if (this.esFormatoPreoperacional(item)) {
        return !mensualVencida;
      }

      return mensualVencida;
    },

    fechaSoloDia(valor) {
      if (!valor) return null;
      if (valor instanceof Date) {
        if (Number.isNaN(valor.getTime())) return null;
        return new Date(valor.getFullYear(), valor.getMonth(), valor.getDate());
      }
      if (typeof valor !== "string") return null;

      const coincidencia = valor.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (coincidencia && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(valor.trim())) {
        const anio = Number(coincidencia[1]);
        const mes = Number(coincidencia[2]);
        const dia = Number(coincidencia[3]);
        if (anio && mes && dia) {
          return new Date(anio, mes - 1, dia);
        }
      }

      const fecha = this.parsearFechaHora(valor);
      if (!fecha || Number.isNaN(fecha.getTime())) {
        return null;
      }
      return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
    },

    ultimaInspeccionMensual(viaje) {
      const delVehiculo =
        (viaje &&
          viaje.vehiculo &&
          (viaje.vehiculo.ultima_inspeccion_vehiculo ||
            viaje.vehiculo.ultimaInspeccionVehiculo)) ||
        null;
      const delCruce = (this.arrayFinal || []).find(
        (item) => this.esFormatoMensual(item) && item.info && item.info.id,
      );
      const deLista = delCruce ? delCruce.info : null;
      if (!delVehiculo) return deLista;
      if (!deLista) return delVehiculo;
      return Number(deLista.id) > Number(delVehiculo.id) ? deLista : delVehiculo;
    },

    fechaVencimientoDeMensual(ultima, formato) {
      if (ultima && ultima.fecha_vencimiento) {
        return this.fechaSoloDia(ultima.fecha_vencimiento);
      }
      if (!ultima) return null;
      const inicio = this.fechaSoloDia(
        ultima.fecha_inicio || ultima.created_at,
      );
      if (!inicio) return null;
      const dias = this.diasPeriocidad(
        formato || (ultima && ultima.formato_inspeccion) || {},
      );
      const diasVence = dias === 12 ? 365 : dias > 0 ? dias : 30;
      const vencimiento = new Date(inicio.getTime());
      vencimiento.setDate(vencimiento.getDate() + diasVence);
      return vencimiento;
    },

    mensualEstaVencida(viaje, item) {
      const ultima = this.ultimaInspeccionMensual(viaje);
      if (!ultima) {
        return true;
      }
      const formato = (item && item.info_formato) || null;
      const vencimiento = this.fechaVencimientoDeMensual(ultima, formato);
      const hoy = this.fechaSoloDia(new Date());
      if (!vencimiento || !hoy) {
        return true;
      }
      return hoy.getTime() > vencimiento.getTime();
    },

    mostrarNombreUltimaMensual(item) {
      if (!this.esFormatoMensual(item)) {
        return false;
      }
      const nombreUltima = this.nombreFormatoUltimaMensual(this.entidad);
      const nombreFila =
        item && item.info_formato && item.info_formato.nombre;
      return !!(nombreUltima && nombreUltima !== nombreFila);
    },

    formatearFechaCorta(valor) {
      if (!valor) {
        return "";
      }

      if (typeof valor === "string") {
        const coincidencia = valor.match(
          /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/,
        );
        if (coincidencia) {
          return (
            coincidencia[1] +
            "-" +
            coincidencia[2] +
            "-" +
            coincidencia[3] +
            " " +
            (coincidencia[4] || "00") +
            ":" +
            (coincidencia[5] || "00")
          );
        }
      }

      const fecha =
        valor instanceof Date ? valor : this.parsearFechaHora(valor);
      if (!fecha || Number.isNaN(fecha.getTime())) {
        return "";
      }
      const pad = (n) => String(n).padStart(2, "0");
      return (
        fecha.getFullYear() +
        "-" +
        pad(fecha.getMonth() + 1) +
        "-" +
        pad(fecha.getDate()) +
        " " +
        pad(fecha.getHours()) +
        ":" +
        pad(fecha.getMinutes())
      );
    },

    nombreFormatoUltimaMensual(viaje) {
      const ultima = this.ultimaInspeccionMensual(viaje);
      if (!ultima) return "";
      return (
        ultima.nombre_formato ||
        (ultima.formato_inspeccion && ultima.formato_inspeccion.nombre) ||
        ""
      );
    },

    mensualHechaEnDiaAnterior(viaje) {
      const ultima = this.ultimaInspeccionMensual(viaje);
      if (!ultima) return false;
      const fechaMensual = this.fechaSoloDia(
        ultima.fecha_inicio || ultima.created_at,
      );
      const hoy = this.fechaSoloDia(new Date());
      return !!(fechaMensual && hoy && hoy.getTime() > fechaMensual.getTime());
    },

    puedeCrearInspeccion(item) {
      if (!item || (item.info && item.info.id) || !this.entidad) {
        return false;
      }

      if (this.esFormatoPreoperacional(item) || this.esFormatoMensual(item)) {
        return false;
      }

      const formato = item.info_formato || {};
      const tieneGuia = this.entidad.guia_id != null;

      if (formato.tipo_operacion == 2 && !tieneGuia) {
        return false;
      }
      if (formato.tipo_operacion == 1 && tieneGuia) {
        return false;
      }

      return true;
    },

    async getListaPeriocidad() {
      if (this.listaPeriocidad && this.listaPeriocidad.length > 0) {
        return;
      }
      try {
        const response = await axios.get("/api/lista/238");
        const data = response.data;
        if (Array.isArray(data)) {
          this.listaPeriocidad = data;
        } else if (data && Array.isArray(data.data)) {
          this.listaPeriocidad = data.data;
        } else {
          this.listaPeriocidad = [];
        }
      } catch (e) {
        this.listaPeriocidad = [];
      }
    },

    permiteInspeccionMensual(viaje, item) {
      if (!viaje) {
        return false;
      }
      return this.mensualEstaVencida(viaje, item);
    },

    permiteInspeccionPreoperacional(viaje) {
      if (!viaje) {
        return false;
      }
      if (this.mensualEstaVencida(viaje)) {
        return false;
      }
      return true;
    },

    valInspeccionFechas(viaje, item) {
      return this.mensualEstaVencida(viaje, item);
    },

    valInspeccionFechasMsg(viaje) {
      const ultima = this.ultimaInspeccionMensual(viaje);
      if (!ultima) return "Sin inspección";

      const vencimiento = this.fechaVencimientoDeMensual(ultima);
      const hoy = this.fechaSoloDia(new Date());
      const textoVencimiento = this.formatearFechaCorta(
        ultima.fecha_vencimiento || vencimiento,
      );

      if (!textoVencimiento) {
        return "Sin fecha de vencimiento";
      }

      const vencida =
        hoy && vencimiento && hoy.getTime() > vencimiento.getTime();
      return vencida
        ? "Vencida: " + textoVencimiento
        : "Vence: " + textoVencimiento;
    },

    estadoInspeccionVehiculoBadge(viaje) {
      const ultima = this.ultimaInspeccionMensual(viaje);
      let bg = "";
      let puedePreoperacional = false;

      if (ultima) {
        const vencida = this.mensualEstaVencida(viaje);
        bg = vencida ? "bg-danger" : "bg-success";
        puedePreoperacional = !vencida;
      } else {
        bg = "bg-danger";
        puedePreoperacional = false;
      }

      return { bg, puedePreoperacional };
    },

    valInspeccionFechasMsgBadge(viaje) {
      return this.estadoInspeccionVehiculoBadge(viaje).bg;
    },

  },
  mounted() {},
};
</script>
